module.exports = __webpack_public_path__ + "img/Documentation_Collapsed_Small_Button-white.98a068ff.svg";